import Grid from "@material-ui/core/Grid";
import React from "react";
import styled from "styled-components";
import ScrollFix from "../../components/ScrollFix/ScrollFix";

const StyledGrid = styled(Grid)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.5em;
  justify-content: center;
  width: 100%;
  p {
    width: 100%;
    margin: 6px 0;
  }
  .headingFontSize {
    font-size: 20px;
  }
  .updatedDate {
    width: 100%;
    text-align: right;
    font-size: 14px;
    color: ${(props) => props.theme.colors.base.grey};
  }
`;

const StyledWrapper = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 50px;
  -webkit-box-shadow: 0px 0px 8px 0px
    ${(props) => props.theme.colors.base.lightGrey};
  -moz-box-shadow: 0px 0px 8px 0px
    ${(props) => props.theme.colors.base.lightGrey};
  box-shadow: 0px 0px 8px 0px ${(props) => props.theme.colors.base.lightGrey};
`;

const StyledHeadingContainer = styled.div`
  width: 100%;
  text-align: center;
  font-size: 30px;
  padding-bottom: 40px;
`;

const StyledStaticHeight = styled.div`
  width: 100%;
  height: 20px;
`;

const StyledText = styled.div`
  font-size: 16px;
`;

const ZipangTermsAndConditionPage = () => {
  return (
    <Grid container={true} spacing={0}>
      <ScrollFix />
      <StyledGrid item={true} xs={12}>
        <StyledWrapper item={true} xs={10} md={10} sm={10} lg={6} xl={6}>
          <Grid container={true} spacing={0}>
            <StyledHeadingContainer>
              <u>Terms & Conditions</u>
            </StyledHeadingContainer>

            <p className="fontBold headingFontSize">
              1. LIVE SELLER AGREEMENT
              <br />
              ライブセラー参加契約書
            </p>

            <p className="fontBold">Article 1 – Purpose</p>
            <p>
              This Agreement defines the terms under which the Live Seller
              participates in the Jewel Live marketplace operated by My Auctions
              Co Ltd.
            </p>

            <p className="fontBold">第1条（目的）</p>
            <p>
              本契約は、株式会社マイオークションズ（以下「運営者」という）が運営する
              「Jewel
              Live」において、ライブセラーがライブ販売活動に参加する際の条件を定めることを目的とする。
            </p>

            <p className="fontBold">Article 2 – Participation</p>
            <p>
              The Live Seller may participate in live selling sessions upon
              approval by the operator.
            </p>

            <p className="fontBold">第2条（参加）</p>
            <p>
              ライブセラーは、運営者の承認を得た場合に限り、 Jewel
              Liveのライブ販売セッションに参加することができる。
            </p>

            <p className="fontBold">Article 3 – Sales Activity</p>
            <p>
              Live Sellers may present and sell jewellery items listed by
              exhibitors or consignors during their allocated selling slot.
            </p>

            <p className="fontBold">第3条（販売活動）</p>
            <p>
              ライブセラーは、割り当てられた販売時間内において、
              出展者または出品者が提供する商品を紹介し販売することができる。
            </p>

            <p className="fontBold">Article 4 – Prohibition of Holding Items</p>
            <p>
              Live Sellers are not permitted to reserve or hold items without
              confirming a completed transaction.
            </p>

            <p className="fontBold">第4条（取り置きの禁止）</p>
            <p>
              ライブセラーは、販売が確定していない商品について取り置きを行ってはならない。
            </p>

            <p className="fontBold">Article 5 – Final Sales</p>
            <p>
              All sales conducted through the Jewel Live platform are final and
              non-refundable.
            </p>

            <p className="fontBold">第5条（販売の確定）</p>
            <p>
              Jewel Liveを通じて成立した販売は最終確定とし、
              販売成立後のキャンセルまたは返金は認められない。
            </p>

            <p className="fontBold">Article 6 – Compliance</p>
            <p>
              The Live Seller shall comply with all applicable Japanese laws and
              marketplace rules.
            </p>

            <p className="fontBold">第6条（法令遵守）</p>
            <p>
              ライブセラーは、日本の関連法令および運営者の定める規則を遵守するものとする。
            </p>

            <p className="fontBold headingFontSize">
              2. EXHIBITOR AGREEMENT
              <br />
              出展契約書
            </p>

            <p className="fontBold">Article 1 – Purpose</p>
            <p>
              This Agreement defines the terms under which the Exhibitor
              participates in the Jewel Live exhibition event.
            </p>

            <p className="fontBold">第1条（目的）</p>
            <p>
              本契約は、Jewel
              Liveイベントにおける出展者の参加条件を定めるものである。
            </p>

            <p className="fontBold">Article 2 – Booth Participation</p>
            <p>
              Exhibitors may participate in the event by reserving a booth
              provided by the organizer.
            </p>

            <p className="fontBold">第2条（出展）</p>
            <p>
              出展者は、運営者が提供するブースを利用してイベントに参加することができる。
            </p>

            <p className="fontBold">Article 3 – Booth Fee</p>
            <p>
              The Exhibitor shall pay the designated exhibition fee prior to the
              event.
            </p>

            <p className="fontBold">第3条（出展料）</p>
            <p>出展者は、イベント開催前に所定の出展料を支払うものとする。</p>

            <p className="fontBold">Article 4 – Product Responsibility</p>
            <p>
              The Exhibitor is responsible for the authenticity, ownership, and
              legality of all products displayed.
            </p>

            <p className="fontBold">第4条（商品責任）</p>
            <p>
              出展者は、展示および販売する商品の真贋、所有権および合法性について責任を負うものとする。
            </p>

            <p className="fontBold">Article 5 – Commission</p>
            <p>
              The operator shall not charge sales commission on items sold by
              exhibitors through their booth participation.
            </p>

            <p className="fontBold">第5条（手数料）</p>
            <p>
              出展者が自社ブースを通じて販売した商品について、
              運営者は販売手数料を請求しない。
            </p>

            <p className="fontBold">Article 6 – Liability</p>
            <p>
              The operator shall not be liable for disputes arising from product
              authenticity, valuation, or buyer transactions.
            </p>

            <p className="fontBold">第6条（免責）</p>
            <p>
              商品の真贋、評価または取引に関する紛争について、
              運営者は責任を負わない。
            </p>

            <p className="fontBold headingFontSize">
              3. CONSIGNMENT AGREEMENT
              <br />
              出品委託契約書
            </p>

            <p className="fontBold">Article 1 – Purpose</p>
            <p>
              This Agreement defines the terms under which the Consignor
              consigns jewellery to be sold through the Jewel Live platform.
            </p>

            <p className="fontBold">第1条（目的）</p>
            <p>
              本契約は、出品者がJewel
              Liveプラットフォームを通じて商品を販売委託する際の条件を定めるものである。
            </p>

            <p className="fontBold">Article 2 – Consignment</p>
            <p>
              The Consignor may consign pawn-origin jewellery inventory for sale
              during Jewel Live events.
            </p>

            <p className="fontBold">第2条（出品）</p>
            <p>
              出品者は、Jewel
              Liveイベントにおいて質流れジュエリーを販売委託することができる。
            </p>

            <p className="fontBold">Article 3 – Commission</p>
            <p>
              A sales commission of 5% shall be charged on successfully sold
              items.
            </p>

            <p className="fontBold">第3条（販売手数料）</p>
            <p>
              販売が成立した商品については、販売価格の5％を手数料として運営者に支払うものとする。
            </p>

            <p className="fontBold">Article 4 – Ownership and Authenticity</p>
            <p>
              The Consignor guarantees that all items submitted are legally
              owned and authentic.
            </p>

            <p className="fontBold">第4条（所有権および真贋）</p>
            <p>
              出品者は、出品する商品の所有権および真正性を保証するものとする。
            </p>

            <p className="fontBold">Article 5 – Settlement</p>
            <p>
              The operator shall settle payment to the Consignor after deducting
              the applicable commission.
            </p>

            <p className="fontBold">第5条（精算）</p>
            <p>
              運営者は、販売成立後、所定の手数料を差し引いた金額を出品者へ支払うものとする。
            </p>

            <p className="fontBold">Article 6 – Unsold Items</p>
            <p>
              Unsold items may be returned to the Consignor or re-listed in
              future events upon mutual agreement.
            </p>

            <p className="fontBold">第6条（未販売商品）</p>
            <p>
              未販売の商品については、出品者へ返却するか、
              双方の合意により次回イベントへ再出品することができる。
            </p>

            <StyledText className="updatedDate">
              Last Updated on: 12 March, 2026
            </StyledText>
          </Grid>
        </StyledWrapper>
      </StyledGrid>
    </Grid>
  );
};

export default ZipangTermsAndConditionPage;
